import React, { useEffect, useState } from "react";

/**
 * PetalRain - falling petals + hearts overlay.
 * When `trigger` changes, spawns a burst of animated petals.
 */
const PETAL_SVG = (color) => (
    <svg viewBox="0 0 40 40" width="28" height="28" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 4 C 30 10, 34 22, 26 32 C 22 36, 18 36, 14 32 C 6 22, 10 10, 20 4 Z"
            fill={color}
            opacity="0.9"
        />
    </svg>
);

const HEART_SVG = (color) => (
    <svg viewBox="0 0 32 32" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 28 C 6 20, 2 14, 6 9 C 10 4, 15 8, 16 11 C 17 8, 22 4, 26 9 C 30 14, 26 20, 16 28 Z"
            fill={color}
        />
    </svg>
);

const COLORS = ["#FDB8C0", "#FFDAB9", "#F4DCD6", "#E2959D", "#C7D3C4", "#FFC6D0"];

export const PetalRain = ({ trigger, count = 40, duration = 6500 }) => {
    const [pieces, setPieces] = useState([]);

    useEffect(() => {
        if (!trigger) return;
        const items = Array.from({ length: count }).map((_, i) => ({
            id: `${trigger}-${i}`,
            left: Math.random() * 100,
            drift: (Math.random() * 200 - 100).toFixed(0) + "px",
            delay: Math.random() * 1.2,
            duration: 4 + Math.random() * 4,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
            isHeart: Math.random() < 0.35,
            size: 0.75 + Math.random() * 0.9,
        }));
        setPieces(items);
        const t = setTimeout(() => setPieces([]), duration + 2000);
        return () => clearTimeout(t);
    }, [trigger, count, duration]);

    if (!pieces.length) return null;

    return (
        <div className="pointer-events-none" data-testid="petal-rain-overlay">
            {pieces.map((p) => (
                <div
                    key={p.id}
                    className="petal"
                    style={{
                        left: `${p.left}%`,
                        animationDuration: `${p.duration}s`,
                        animationDelay: `${p.delay}s`,
                        transform: `scale(${p.size})`,
                        // custom prop consumed by CSS keyframes
                        "--drift": p.drift,
                    }}
                >
                    {p.isHeart ? HEART_SVG(p.color) : PETAL_SVG(p.color)}
                </div>
            ))}
        </div>
    );
};

export default PetalRain;
